<script>
import labelSelect from '../labelSelect';
import store from '../../store';
import { getQueryString } from '../../../../../common/util';
export default {
    data() {
        return {
            cityId: store.form.position.cityId
        };
    },
    computed: {
        city: {
            get() {
                 return store.form.position;
            },
            set(val) {
                store.form.position = val;
            }
        }
    },
    mounted() {
        this.$eventBus.$on('cityData', (cityData) => {
            this.city = {...cityData};
        })
    },
    watch: {
       
    },
    components: {
        labelSelect
    },
    methods: {
        showSlider() {
            vm.showProvinceSidebar();
        }
    }
}
</script>

<template>
<div>
    <div class="label-select" @click="showSlider">
        <em>购车城市</em>
        <div class="value">{{city.cityName}}</div>
        <img src="../../../assets/arrow-right.png" alt="">
    </div>
</div>
</template>

<style lang="stylus" scoped>
.label-select
    position relative
    border-bottom 0.053rem solid #ebebeb
    em
        position absolute
        top 0
        bottom 0
        left 0
        margin auto
        height 1rem
        line-height 1rem
        font-size 0.85rem
        font-style normal
        color #333
    .value 
        padding 0.74rem 1rem 0.74rem 4.5rem
        width 100%
        height 2.48rem
        line-height 1rem
        border 0
        box-shadow none
        box-sizing border-box
        font-size 0.85rem
        color #333
        outline 0
    img
        position absolute
        top 0
        bottom 0
        right 0
        margin auto
</style>